module.exports = __webpack_public_path__ + "img/masterclass_male.69ce94b2.jpg";